import React from 'react'

const TimeDurationContainer = ({ children }) => {
  return (
    <div className="w-40p flex flex-column flex-between">

      {children}

    </div>
  )
}

export default TimeDurationContainer
